import React, {useState} from "react";
import "./ManagementDriverCard.scss";
import {courierManagerOrderUpdate_api} from "../SendManagementService";

function ManagementDriverCard({item,order,closeModal}) {

    const [selectDriverLadda,set_selectDriverLadda] = useState(false)

    const courierManagerOrderUpdate_func = async () =>{
        set_selectDriverLadda(true)
        try{
            const response = await courierManagerOrderUpdate_api(order.uid,item.uid)
            set_selectDriverLadda(false)
            console.log(response.data)
            closeModal(response.data.courier)
        }catch (e) {
            set_selectDriverLadda(false)
            closeModal(false)
        }
    }

    return(
        <div className="current-card-container">
            <div
                className={!item.driver?"current-card-btn-active":"current-card-btn-deActive"} style={{
                    maxWidth:40,
                    minWidth:40,
                    display:'flex',
                    justifyContent:'center'
                }}>
                {!selectDriverLadda?<span onClick={()=>{
                    courierManagerOrderUpdate_func(item.uid)
                }}
                >{item.driver?item.driver.fname+" "+item.driver.lname:"انتخاب"}</span>:<i className="fa fa-spinner fa-spin"></i>}
            </div>
            <div className="history-card-info">
                <div className="current-card-info">
                    <span className="names" style={{fontSize:13,fontFamily:"YekanRegular"}}>{item.first_name+" "+item.last_name}</span>
                    <span className="status">{item.phone}</span>
                </div>
                <img src={item.image} alt=""/>
            </div>
        </div>
    )

}

export {ManagementDriverCard}
